import SignUpEventsReporter from './SignUpEventReporter';

export default SignUpEventsReporter;
